import Drawer from '@mui/joy/Drawer';
import MenuList from './ui/MenuList';

export default function Sidebar({
  isOpenSidebar,
  setIsOpenSidebar,
}: {
  isOpenSidebar: boolean;
  setIsOpenSidebar: any;
}) {
  return (
    <>
      <Drawer
        anchor="left"
        open={isOpenSidebar}
        onClose={() => setIsOpenSidebar(false)}
      >
        {<MenuList />}
      </Drawer>
    </>
  );
}
